<template>
    <div >
<!--        <div class="section-title" >Profile Trends</div>-->
        <template v-for="categoryId in profile.categoryIdsTaken" :key="categoryId">
            <div
                v-if="measuresCategoriesById[categoryId] && !measuresCategoriesById[categoryId].trendsAreNotChartable"
                class="pdf-avoid-page-break"
            >
                <div style="width: 100%; background-color: #F4F4F4; display: flex; padding: 5px 10px; margin-bottom: 10px">
                    <div style="font-weight: 800; text-transform: uppercase; color: #898C90; flex: 1">
                        {{measuresCategoriesById[categoryId].fullLabel ? measuresCategoriesById[categoryId].fullLabel : measuresCategoriesById[categoryId].label}}
                    </div>

                </div>
                <ProfileAttentionTrends :profile="profile" :category-id="categoryId"/>

            </div>
        </template>

    </div>
</template>

<script>
import ProfileAttentionTrends from "@/components/Profile/ProfileAttentionTrends";
import {measuresCategoriesById} from "@/js/shared/constants";

export default {
    name: "ProfileTrends",
    components: {ProfileAttentionTrends},
    props: {
        profile: {
            required: true
        }
    },
    data() {
        return {
            measuresCategoriesById,
        }
    }
}
</script>

<style scoped>

</style>